export type CraftLocale = {
    code: string;
    craftSiteId: number;
    language: string;
};

export const craftLocales: CraftLocale[] = [
    {
        code: 'nl',
        craftSiteId: 1,
        language: 'nl-NL'
    },
    {
        code: 'en',
        craftSiteId: 2,
        language: 'en-150'
    }
];

export function craftSiteIdForPath(path: string): number {
    return path.startsWith('/en') ? 2 : 1;
}
